<template>
  <TacheItem
    v-if="tache.type_tache === 'devis_to_cmd'"
    :tache="tache"
  >
    <template #icons>
      <IconFileDevis />
      <UilArrowRight />
      <UilFileCheck />
    </template>
    <template #libelle>
      <div v-if="tache.devis && tache.commande">
        <span>
          {{ $t("devis.devis") }} #{{ tache.devis.id_4d }}
        </span>
        <UilArrowRight />
        <router-link
          :to="{ name: 'commandes_factures_commandes_item', params: { id: tache.commande.id, }, }"
        >
          {{ $t("commande.commande") }} #{{ tache.commande.id_4d }}
        </router-link>
      </div>
      <div v-else>
        {{ tache.type_tache_verbose }}
      </div>
    </template>
  </TacheItem>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { UilArrowRight, UilFileCheck } from "@lde/vue-unicons";

import Tache from "@/domains/taches/tache";
import TacheItem from "@/components/taches/TacheItem.ts.vue";
import IconFileDevis from "@/components/icons/IconFileDevis.vue";

export default defineComponent({
  name: "TachePresenter",
  components: {
    TacheItem,
    IconFileDevis,
    UilArrowRight,
    UilFileCheck,
  },
  props: {
    tache: {
      type: Tache,
      required: true,
    },
  },
});
</script>
